
export const OurPdVData = [
    {
        id: "1",
        citta: "Apricena",
        indirizzo: "S.S. 89 KM 8,400",
        orario1: "Dal Lunedi al Venerdi 08:00-13:00 | 15:00-19:00",
        orario2: "Sabato 08:00-13:00",
        orario3: "Domenica 08:00-13:00",
        telefono: "+39 0882 645502",
        email: "apricena@italycashpuglia.it",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2975.2395349463413!2d15.443528490496403!3d41.7800510974344!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13376bd7ebe4aff3%3A0xd348a78ff8ce6724!2scash%20%26%20carry%20tato%27!5e0!3m2!1sit!2sit!4v1737567962175!5m2!1sit!2sit"
    },
    {
        id: "2",
        citta: "Foggia",
        indirizzo: "C.SO DEL MEZZOGIORNO KM1",
        orario1: "Dal Lunedi al Venerdi 08:00-13:00 | 15:00-19:00",
        orario2: "Sabato 08:00-12:30",
        orario3: "Domenica 08:00-12:30",
        telefono: "+39 0881 661378",
        email: "foggia@italycashpuglia.it",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2990.5721308784077!2d15.569691576568385!3d41.44850484220105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1339d83573680eab%3A0xe5f2e8d13f427d87!2sItaly%20Cash!5e0!3m2!1sit!2sit!4v1737568747171!5m2!1sit!2sit"
    },
    {
        id: "3",
        citta: "Barletta",
        indirizzo: "VIA FOGGIA 177",
        orario1: "Dal Lunedi al Giovedi 08:00-13:00 | 15:00-19:00",
        orario2: "Venerdi 08:00-19:00",
        orario3: "Sabato 08:00-13:00",
        orario4: "Domenica Chiuso",
        telefono: "+39 0883 310819",
        email: "barletta@italycashpuglia.it",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2996.37334957312!2d16.23906087656371!3d41.32249420001706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13381ea559002237%3A0x4552562b67eb6553!2sItaly%20cash%20%26%20carry!5e0!3m2!1sit!2sit!4v1737568833318!5m2!1sit!2sit"
    },
    {
        id: "4",
        citta: "Bari",
        indirizzo: "VIA ACCOLTI GIL Z.I.",
        orario1: "Dal Lunedi al Venerdi 08:00-19:00",
        orario2:"Sabato 08:00-13:00",
        orario3:"Domenica 08:00-13:00",
        telefono: "+39 080 5312988",
        email: "bari@italycashpuglia.it",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d24053.03528781775!2d16.79483820630176!3d41.09894305583564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1347ef2de5e7b4ff%3A0xe80a8d34642fe7e4!2sPanta%20Market!5e0!3m2!1sit!2sit!4v1737568887052!5m2!1sit!2sit"
    },
    {
        id: "5",
        citta: "Fasano",
        indirizzo: "CONTRADA SAVELLETRI",
        orario1: "Dal Lunedi al Venerdi 08:00-13:00 | 15:00-19:00",
        orario2: "Sabato 08:00-13:00",
        orario3: "Domenica Chiuso",
        telefono: "+39 080 4425409",
        email: "fasano@italycashpuglia.it",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3017.723701776953!2d17.38639087654644!3d40.85598962878746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1346497cb4aa335d%3A0xbd6a462e2e33991a!2sPantamarket!5e0!3m2!1sit!2sit!4v1737568919697!5m2!1sit!2sit"
    },
    {
        id: "6",
        citta: "Maglie",
        indirizzo: "ZONA INDUSTRIALE",
        orario1: "Dal Lunedi al Venerdi 08:00-19:00",
        orario2: "Sabato 08:00-13:00",
        orario3: "Domenica 08:00-13:00",
        telefono: "+39 0836 426545",
        email: "maglie@italycashpuglia.it",
        url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d906.8244389569339!2d18.289720214976175!3d40.13823662022241!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13443d847f2a594f%3A0xe71ff053652d9fc5!2sTat%C3%B3%20paride!5e0!3m2!1sit!2sit!4v1737568984545!5m2!1sit!2sit"
    },
];
export default OurPdVData;